import { render } from "./FuelInputConsumptionTable.vue?vue&type=template&id=2fe8d0be&scoped=true&lang=true"
import script from "./FuelInputConsumptionTable.vue?vue&type=script&lang=js"
export * from "./FuelInputConsumptionTable.vue?vue&type=script&lang=js"

import "./FuelInputConsumptionTable.vue?vue&type=style&index=0&id=2fe8d0be&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fe8d0be"]])

export default __exports__